<h1>
  <span id='breadcrumbs' *ngFor="let item of validatedParts; let i = index">
    <span *ngIf="i > 0">/</span>
    <a href (click)="goToLoc(item.data)" *ngIf="i < validatedParts.length - 1 && item.data">{{ item.name }}</a>
    <span
      *ngIf="i == validatedParts.length - 1 || !item.data"
      [ngStyle]="{ 'font-weight': i === validatedParts.length - 1 ? 'bold' : '' }"
      >{{ item.name }}</span
    >
  </span>
</h1>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/breadcrumb/breadcrumb.component.html